import { AuthUser } from '../models';
import { OauthService } from '../services';
import cloneDeep from "lodash-es/cloneDeep";
import router from '../routes'
import store from '../store'
let _jwt = '';
let _new_jwt = '';
let _is_master_token = false;

export interface IVerificationJWTDecoded {
    companyId?:      string;
    userId?:         string;
    email?:			 string;
    token?:          string;
    expirationTime?: number;
    setToAll?:       boolean;
}

export const getDecodedJWT = (token: string) => {
  return JSON.parse(atob(token.split('.')?.[1]?.replace(/-/g, '+')?.replace(/_/g, '/')))
}

export const isJwtTokenExpired = (token: string | undefined) => {
  try {
    if (!token) {
      throw new Error('Empty token')
    }
    const decodedPayload = JSON.parse(atob(token.split('.')?.[1]?.replace(/-/g, '+')?.replace(/_/g, '/')))
    // Consider token expired if less than 5 minutes (300000 ms) remaining
    const buffer = 300000 // 5 minutes in milliseconds
    return Date.now() >= (decodedPayload?.exp * 1000 - buffer)
  } catch (error) {
    console.warn('Error while checking token', token, error)
    return true
  }
}

/**
 * We are adding these functions to retrieve the current jwts without refreshing them
 * This is to avoid the circular dependency issue with the OauthService
 * The OauthService is using the jwt_helper to refresh the token
 * The jwt_helper is using the OauthService to refresh the token
 * This creates a circular dependency
 *
 * This is supposed to be used in areas where there is a possibility of a circular dependency
 */

export const getV1JWTWithoutRefresh = () => {
  return _jwt
}

export const getV2JWTWithoutRefresh = () => {
  return _new_jwt
}

export const getJWT = async (isNew: boolean = false) => {
  try {
    if (
      (_jwt && isJwtTokenExpired(_jwt)) ||
      (_new_jwt && isJwtTokenExpired(_new_jwt))
    ) {
      const authUser: AuthUser = cloneDeep(await store.dispatch('auth/get'))
      const refreshToken = authUser?.refreshJwt
      const newRefreshToken = authUser?.refreshToken
      if (isJwtTokenExpired(refreshToken)) {
        console.info('Token Expired. Please login again!')

        logout()
        return ''
      }
      if (refreshToken) {
        const response = await OauthService.refreshToken(refreshToken, newRefreshToken)
        // Update authUser with v1 tokens, if available
        if (response.v1JWTs) {
          authUser.jwt = response.v1JWTs.jwt
          authUser.refreshJwt = response.v1JWTs.refreshJwt
        } else {
          authUser.jwt = response.jwt
        }
        authUser.authToken = response.authToken
        authUser.refreshToken = response.refreshToken
        await store.dispatch('auth/set', authUser)
        setJWT(authUser.jwt, authUser.authToken, true)
      }
    }
    if (isNew) {
      return _new_jwt
    }
    return _jwt
  } catch (error) {
    console.info('Error while refreshing token. Please login again!', error)
    logout()
  }
}

const logout = async () => {
  await store.dispatch('logout')
  await router.push({ name: 'login', params: { logout: 'true' } })
}

export const setJWT = (token: string, new_jwt: string, is_master_token: boolean = false) => {
    _jwt = token
    _new_jwt = new_jwt
    _is_master_token = is_master_token
};